



export const locale = {
    lang: 'fr',
    data: {
        'NOTIFICATION': {
            'TITLE': '',
            'SEARCH': 'Rechercher',

            'NAME': 'Name',

            'ACTION_RAISE': 'Action raise',

            'CRITIQUE': 'Critique',

            'DATE': 'Date',

            'REPEATABILITY': 'Repeatability',

            'SOURCE': 'Source',

            'STATUT': 'Statut',

            'TYPE': 'Type',

            'NEXT_NOTIFICATION': 'Next notification',
            'INBOX': 'Boîte de réception',
            'WATCHING': 'Archive',
            'MARK_AS_READ': 'Marquer comme lue',
            'MARK_AS_UNREAD': 'Marquer comme non lue',
            'MARK_ALL_AS_READ': 'Marquer toutes comme lues',
            'MARK_ALL_AS_UNREAD': 'Marquer toutes comme non lues',
            'CLEAR': 'Effacer',
            'CLEAR_ALL': 'Effacer toutes',
            'NO_NOTIFICATIONS': 'Pas de notifications',
            'NO_NOTIFICATIONS_MESSAGE': 'Lorsque vous aurez des notifications, elles apparaîtront ici.',
            'NOTIFICATIONS': 'Notifications',
            
        }
    }
};